import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";

export interface ExcludedVariablesState {
  loading: LoadingState;
}
export const initialExcludedVariablesState: ExcludedVariablesState = {
    loading: LoadingState.idle,
};
